/**
 * Triggers a browser download for a file that is already hosted at a URL,
 * e.g. a pre-signed S3 link returned by an export/template API.
 *
 * The `download` attribute is a best effort hint: browsers ignore it for
 * cross origin URLs and fall back to the name configured on the bucket.
 *
 * @param fileUrl - Absolute URL of the file to download.
 * @param fileName - File name (or storage key) returned by the API.
 * @param fallbackFileName - Used when the API does not return a usable name.
 */
export const triggerBrowserDownload = (
  fileUrl: string,
  fileName?: string,
  fallbackFileName = "download.xlsx"
) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  // API file names may be storage keys ("folder/OMOAGNT000098.xlsx") — keep the leaf.
  link.setAttribute("download", fileName?.split("/").pop() || fallbackFileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
